
const namespaced = true;

const state = {
};

const mutations = {
};

const actions = {
  async addTag({ dispatch }, tag) {
    const dbTag = await dispatch(`model/tag/addTag`, tag, { root: true });

    return dbTag;
  },
  async addTagForMaker({ dispatch }, tag) {
    const dbTag = await dispatch(`model/tag/addTagForMaker`, tag, { root: true });

    return dbTag;
  },
  async addTagForClient({ dispatch }, tag) {
    const dbTag = await dispatch(`model/tag/addTagForClient`, tag, { root: true });

    return dbTag;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
